import axios from 'axios';
import {appUrls, portalUrls} from './urls';

/**
 * connect to app backend
 */
// const appInstance = axios.create({
//   baseURL: 'api/v2/'
// });

/**
 * fetches list of countries
 * @param {{search:String}} param0
 * @returns
 */
const fetchCountryList = async ({ search = '' }) => {
  const { countriesListUrl } = appUrls;
  try {
    const url = countriesListUrl + search;
    return await axios.get(url);
  } catch (error) {
    throw error;
  }
};

const fetchCountryListForPhoneNumber = async (params = { }) => {
  const { countriesListForPhoneNumberUrl } = appUrls;
  try {
    return await axios.get(countriesListForPhoneNumberUrl, { params });
  } catch (error) {
    throw error;
  }
};

/**
 * fetches profile data for a user
 * @returns
 */
const getProfile = async () => {
  const { profileSubUrl } = portalUrls;
  try {
    const updateResponse = await axios.get(profileSubUrl);
    return updateResponse;
  } catch (error) {
    throw error;
  }
};

const updateProfile = async updateData => {
  const { profileSubUrl } = portalUrls;
  try {
    const updateResponse = await axios.post(profileSubUrl, updateData);
    return updateResponse;
  } catch (error) {
    throw error;
  }
};

/**
 *
 * @param {string} id
 * @param {{}} updateDetails
 * @returns
 */
const updateEducationDetails = async (id, updateDetails) => {
  const { educationDetailSubUrl } = portalUrls;
  try {
    const updateResponse = await axios.put(educationDetailSubUrl + id, updateDetails);
    return updateResponse;
  } catch (error) {
    throw error;
  }
};

const addEducationDetails = async addDetails => {
  const { educationDetailSubUrl } = portalUrls;
  try {
    const updateResponse = await axios.post(educationDetailSubUrl, addDetails);
    return updateResponse;
  } catch (error) {
    throw error;
  }
};

const getEducationDetails = async () => {
  const { educationDetailsSubUrl } = portalUrls;
  try {
    const updateResponse = await axios.get(educationDetailsSubUrl);
    return updateResponse;
  } catch (error) {
    throw error;
  }
};

const updateTestScores = async updateData => {
  const { testScoresSubUrl } = portalUrls;
  try {
    const updateResponse = await axios.put(testScoresSubUrl, updateData);
    return updateResponse;
  } catch (error) {
    throw error;
  }
};

/**
 * fetches all available degree levels
 * @returns
 */
const fetchDegreeLevels = async () => {
  const { degreeLevelsSubUrl } = portalUrls;
  try {
    const updateResponse = await axios.get(degreeLevelsSubUrl);
    return updateResponse;
  } catch (error) {
    throw error;
  }
};
export {
  fetchCountryList,
  fetchDegreeLevels,
  updateProfile,
  updateTestScores,
  getEducationDetails,
  addEducationDetails,
  updateEducationDetails,
  getProfile,
  fetchCountryListForPhoneNumber
};
